import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-denied-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './access-denied-page.component.html',
  styleUrls: ['./access-denied-page.component.scss']
})
export class AccessDeniedOverlayComponent implements OnInit, OnDestroy {

  isOwner?: boolean = false;
  @Input() roleName?: string = '';

  countdown: number = 30;
  private intervalId?: any;

  constructor(private router: Router) {}

  ngOnInit(): void {
    if(this.roleName === 'owner'){
      this.isOwner = true;
    }else{
      this.isOwner = false;
    }
    this.startCountdown();
  }

  startCountdown(): void {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(this.intervalId);  
        this.router.navigate(['/']);
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId); 
    }
  }


}


